import { PIPELINE_ADD_PIPELINE, PIPELINE_EDIT_PIPELINE, PIPELINE_REMOVE_PIPELINE, PIPELINE_SET_PRIMARY, PIPELINES_SET, } from "../constants";
import { convertStageFromServer } from "../utils/stage";
const reducer = (state, action) => {
    var _a;
    switch (action.type) {
        case PIPELINES_SET: {
            const pipelines = action.payload;
            const transformStage = (stage) => {
                return Object.assign({}, convertStageFromServer(stage));
            };
            const transformPipeline = (pipeline) => {
                var _a;
                return Object.assign(Object.assign({}, pipeline), { stages: (_a = pipeline.stages) === null || _a === void 0 ? void 0 : _a.map(transformStage), is_primary: pipeline.is_primary === "1" });
            };
            return Object.assign(Object.assign({}, state), { pipelines: pipelines.map(transformPipeline) });
        }
        case PIPELINE_ADD_PIPELINE: {
            const pipeline = action.payload;
            const transformStage = (stage) => {
                return Object.assign({}, convertStageFromServer(stage));
            };
            const transformedPipeline = Object.assign(Object.assign({}, pipeline), { stages: (_a = pipeline.stages) === null || _a === void 0 ? void 0 : _a.map(transformStage), is_primary: false });
            return Object.assign(Object.assign({}, state), { pipelines: [...state.pipelines, transformedPipeline] });
        }
        case PIPELINE_SET_PRIMARY: {
            const primaryPipelineId = action.payload;
            return Object.assign(Object.assign({}, state), { pipelines: state.pipelines.map((pipeline) => (Object.assign(Object.assign({}, pipeline), { is_primary: pipeline.id === primaryPipelineId }))) });
        }
        case PIPELINE_EDIT_PIPELINE: {
            const pipeline = action.payload;
            return Object.assign(Object.assign({}, state), { pipelines: state.pipelines.map((p) => p.id === pipeline.id ? pipeline : p) });
        }
        case PIPELINE_REMOVE_PIPELINE: {
            const pipelineId = action.payload;
            return Object.assign(Object.assign({}, state), { pipelines: state.pipelines.filter((pipeline) => pipeline.id !== pipelineId) });
        }
        default:
            return state;
    }
};
export { reducer };
